import React from 'react';
import { connect } from 'react-redux';

import Home from 'screens/Home';
import Login from 'screens/Login';
import Purchase from 'screens/Purchase';
import PurchaseHistory from 'screens/PurchaseHistory';
import UnpaidPurchase from 'screens/UnpaidPurchase';
import ResetPassword from 'screens/ResetPassword';
import Account from 'screens/Account';
import Renew from 'screens/Renew';
import Billing from 'screens/Billing';
import AddCard from 'screens/AddCard';
import SprintSubscriptionScreen from 'screens/Subscription/sprint';
import BypassedSubscriptionScreen from 'screens/Subscription/bypassed';
import QuickSubscriptionScreen from 'screens/Subscription/quick';
import SprintAddDataScreen from 'screens/AddData/sprint';
import BypassedAddDataScreen from 'screens/AddData/bypassed';
import QuickAddDataScreen from 'screens/AddData/quick';
import SprintAddDataPurchase from 'screens/AddDataPurchase/sprint';
import BypassedAddDataPurchase from 'screens/AddDataPurchase/bypassed';
import QuickAddDataPurchase from 'screens/AddDataPurchase/quick';
import SprintInsuranceConfirmScreen from 'screens/InsuranceConfirm/sprint';
import SprintInsurancePlanScreen from 'screens/InsurancePlan/sprint';
import SprintInsuranceDeviceScreen from 'screens/InsuranceDevice/sprint';
import SprintInsuranceScreen from 'screens/Insurance/sprint';
import BypassedInsuranceConfirmScreen from 'screens/InsuranceConfirm/bypassed';
import BypassedInsurancePlanScreen from 'screens/InsurancePlan/bypassed';
import BypassedInsuranceDeviceScreen from 'screens/InsuranceDevice/bypassed';
import BypassedInsuranceScreen from 'screens/Insurance/bypassed';
import QuickInsuranceScreen from 'screens/Insurance/quick';
import QuickInsuranceDeviceScreen from 'screens/InsuranceDevice/quick';
import QuickInsurancePlanScreen from 'screens/InsurancePlan/quick';
import QuickInsuranceConfirmScreen from 'screens/InsuranceConfirm/quick';
import InsurancePurchaseScreen from 'screens/InsurancePurchase';
import InsuranceEligibilityScreen from 'screens/InsuranceEligibility';
import OrderSimScreen from 'screens/OrderSim';
import PaymentArrangementRequest from 'screens/PaymentArrangementRequest';

export const Screen = ({ id, params }) => {
  switch (id) {
    case 'HOME':
      return <Home />;
    case 'LOGIN':
      return <Login />;
    case 'PURCHASE':
      return <Purchase id={params.purchaseId} />;
    case 'PURCHASE_HISTORY':
      return <PurchaseHistory />;
    case 'UNPAID_PURCHASE':
      return <UnpaidPurchase id={params.purchaseId} />;
    case 'RESET_PASSWORD':
      return <ResetPassword />;
    case 'ACCOUNT':
      return <Account />;
    case 'RENEW':
      return <Renew />;
    case 'BILLING':
      return <Billing />;
    case 'ADD_CARD':
      return <AddCard />;
    case 'SPRINT_SUBSCRIPTION':
      return <SprintSubscriptionScreen subId={params.subId} />;
    case 'BYPASSED_SUBSCRIPTION':
      return <BypassedSubscriptionScreen subId={params.subId} />;
    case 'QUICK_SUBSCRIPTION':
      return <QuickSubscriptionScreen subId={params.subId} />;
    case 'SPRINT_ADD_DATA':
      return <SprintAddDataScreen subId={params.subId} />;
    case 'BYPASSED_ADD_DATA':
      return <BypassedAddDataScreen subId={params.subId} />;
    case 'QUICK_ADD_DATA':
      return <QuickAddDataScreen subId={params.subId} />;
    case 'SPRINT_ADD_DATA_PURCHASE':
      return <SprintAddDataPurchase subId={params.subId} planId={params.planId} />;
    case 'BYPASSED_ADD_DATA_PURCHASE':
      return <BypassedAddDataPurchase subId={params.subId} planId={params.planId} />;
    case 'QUICK_ADD_DATA_PURCHASE':
      return <QuickAddDataPurchase subId={params.subId} planId={params.planId} />;
    case 'SPRINT_INSURANCE_CONFIRM':
      return <SprintInsuranceConfirmScreen subId={params.subId} sku={params.sku} insPlanId={params.insPlanId} />;
    case 'SPRINT_INSURANCE_PLAN':
      return <SprintInsurancePlanScreen subId={params.subId} sku={params.sku} />;
    case 'SPRINT_INSURANCE_DEVICE':
      return <SprintInsuranceDeviceScreen subId={params.subId} />;
    case 'SPRINT_INSURANCE':
      return <SprintInsuranceScreen subId={params.subId} />;
    case 'BYPASSED_INSURANCE_CONFIRM':
      return <BypassedInsuranceConfirmScreen subId={params.subId} sku={params.sku} insPlanId={params.insPlanId} />;
    case 'BYPASSED_INSURANCE_PLAN':
      return <BypassedInsurancePlanScreen subId={params.subId} sku={params.sku} />;
    case 'BYPASSED_INSURANCE_DEVICE':
      return <BypassedInsuranceDeviceScreen subId={params.subId} />;
    case 'BYPASSED_INSURANCE':
      return <BypassedInsuranceScreen subId={params.subId} />;
    case 'QUICK_INSURANCE':
      return <QuickInsuranceScreen subId={params.subId} />;
    case 'QUICK_INSURANCE_DEVICE':
      return <QuickInsuranceDeviceScreen subId={params.subId} />;
    case 'QUICK_INSURANCE_PLAN':
      return <QuickInsurancePlanScreen subId={params.subId} sku={params.sku} />;
    case 'QUICK_INSURANCE_CONFIRM':
      return <QuickInsuranceConfirmScreen subId={params.subId} sku={params.sku} insPlanId={params.insPlanId} />;
    case 'INSURANCE_PURCHASE':
      return <InsurancePurchaseScreen purchaseId={params.purchaseId} contractId={params.contractId} />;
    case 'INSURANCE_ELIGIBILITY':
      return <InsuranceEligibilityScreen />;
    case 'ORDER_SIM':
      return <OrderSimScreen />;
    case 'PAYMENT_ARRANGEMENT_REQUEST':
      return <PaymentArrangementRequest />;
    default:
      return null;
  }
};

const mapStateToProps = (state) => ({
  ...state.routing
});

export default connect(
  mapStateToProps
)(Screen);
